// extracted by mini-css-extract-plugin
export default {"component":"PromoCard__component-P9Wq","content":"PromoCard__content-CR4h","tag":"PromoCard__tag-Kloy","spin":"PromoCard__spin-TkMH","pulse":"PromoCard__pulse-Ivit"};